import type { RootLoaderData } from '../types/loaders';

type RemoteUsers = NonNullable<RootLoaderData['user']>['remoteUsers'];

// Streamer URLs carry a single-letter platform code rather than the platform
// name: /t/brukos, not /twitch/brukos. mapPlatform decodes that direction for
// the router; this encodes it.
const platformRouteCode: Record<string, string> = {
  twitch: 't',
  youtube: 'y',
  kick: 'k',
};

const platformPriority = ['twitch', 'youtube', 'kick'];

// getStreamerProfileUrl links to a streamer's page, or returns null when there
// is no username to link to at all. A streamer with no remote identity still
// has an account username and is reachable under the /s/ prefix.
export function getStreamerProfileUrl({
  platform,
  username,
}: {
  platform: string | null | undefined;
  username: string | null | undefined;
}): string | null {
  if (!username) return null;

  const code = (platform && platformRouteCode[platform]) ?? 's';

  return `/${code}/${username}`;
}

export function getStreamerPageUrl({
  remoteUsers,
  username,
}: {
  remoteUsers: RemoteUsers;
  username?: string | null;
}): string | null {
  const platform = remoteUsers ? platformPriority.find((p) => remoteUsers[p]) : undefined;
  if (platform) {
    return getStreamerProfileUrl({ platform, username: remoteUsers[platform].username });
  }

  return getStreamerProfileUrl({ platform: null, username });
}
